export default "__VITE_ASSET__99388302__"